import React from 'react'

const UserBadge = ({data, compact = false, isExpanded = true}) => {
	return (
	<React.Fragment>
		<section className={`w-full !mt-0 ${!compact ? 'pt-8 text-center space-y-1' : 'inline-flex gap-2'}`}>
			<div className='flex items-center'>
			    <div className={`rounded-full tracking-tight ${compact ? 'w-[34px] h-[34px] text-[clamp(12px,6vw,14px)]' : 'w-[60px] h-[60px] md:w-10 md:h-10 lg:w-[60px] lg:h-[60px] mx-auto text-[clamp(12px,6vw,30px)] md:text-[clamp(12px,6vw,14px)] lg:md:text-[clamp(12px,6vw,24px)]'} p-0.5 bg-primary text-white flex items-center justify-center pt-1`}>{data?.firstName?.charAt(0)}{data?.lastName?.charAt(0)}</div>
			</div>

			{isExpanded && (
				<div className=''>
					<div className={`text-[#3D3D3D] font-medium ${compact ? 'text-md' : 'text-lg'}`}>
						{data?.firstName} {data?.lastName}
					</div>
					<div className={`text-[#5D5D5D] ${compact ? 'text-sm' : 'font-medium text-sm'}`}>
						{data?.email}
					</div>
				</div>
			)}
		</section>
    </React.Fragment>
  )
}

export default UserBadge